export const getBundleQuantityCount = (bundleOptions, productType) => {
    if (!bundleOptions) {
        return 1;
    }
    return bundleOptions.reduce((total, bundleOption) => {
        const shouldIncludeInBundleQuantity = productType === "bundle" || bundleOption.type === "multi";
        if (!shouldIncludeInBundleQuantity) {
            return total;
        }
        const { values = [] } = bundleOption;
        const numberOfItemsForSingleProduct = values.reduce((subTotal, product) => subTotal + product.quantity, 0);
        return total + numberOfItemsForSingleProduct;
    }, 0);
};
//# sourceMappingURL=getBundleQuantityCount.js.map